module.exports = __webpack_public_path__ + "static/1141704845-wide.a2882246.jpg";